import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { ScrutinyPopupComponent } from '../scrutiny-popup/scrutiny-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Overlay, OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { ActivatedRoute } from '@angular/router';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { Location } from '@angular/common';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Subscriber } from 'rxjs/internal/Subscriber';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { SuperAdminLoginComponent } from '../super-admin-login/super-admin-login.component';
@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.scss'],

})
export class StudentDetailsComponent implements OnInit, AfterViewInit {

  stepperForm: FormGroup;
  personalDetailsForm: FormGroup;
  contactDetailsForm: FormGroup;
  reservationsDetailsForm: FormGroup;
  qualificationDetailsForm: FormGroup;
  additionalDetailsForm: FormGroup;
  photoSignDetailsForm: FormGroup;
  admissionDetailsForm: FormGroup;
  documentDetailsForm: FormGroup;
  marritalList: any;
  filteredmarritalstatusList: any;
  filteredBloodGroupList: any;
  bloodgroupList: any;
  filteredGenderList: any;
  genderList: any;
  isDivShow: boolean;
  isreadonly = true;
  dialogRef1: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  StateCodeList: any;
  filteredListState: any;
  districtCodeList: any;
  filteredListDistrict: any;
  qualList: any;
  regionList: any;
  filteredRegionList: any;
  filteredDomicileList: any;
  domicileList: any;
  filteredNationalityList: any;
  nationalityList: any;
  filteredMinorityList: any;
  minorityList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  religionList: any;
  filteredReligionList: any;
  specialAbledList: any;
  filteredspecialAbledList: any;
  orphanTypeList: any;
  filteredorphanTypeList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  userImage: any;
  signatureImage: any;
  proId: any;
  facultyList: any;  
  PayBtn = true;
  PayStatus = false;
  FeePaid: string;
  filteredFacultyList: any;
  courseList: any;
  filteredCourseList: any;
  courseStreamList: any;
  filteredStreamList: any;
  examList: any;
  filteredExamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  ducumentList: any;
  ScrutinyLevel: 0;
  UserId: 0;
  ScrutinyId: 0;
  StudentId: any;
  CoCode: 0;
  CgCode: 0;
  SessionId: any;
  LoginName: any;
  FirstName: any;
  MiddleName: any;
  LastName: any;
  from: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  mothertoungList: any;
  filteredMotherToungList: any;
  BranchId = 0;
  subList: any;
  filteredSubList: any;
  PassYearList: any;
  filteredPassYearList: any;
  courseLevelList: any;
  filteredcourseLevelList: any;
  courseQualList: any;
  filteredcourseList: any;
  boardUniList: any;
  filteredboardUniList: any;
  Subs = false;
  OptSub = false;
  Min: any;
  Max: any;
  SubjectName: any[] = [];
  ErrorMessage: string;
  optData: any;
  GroupData: any;
  SubError = false;
  selectedValues: any[] = [];
  Subjects: any[] = [];
  selectedCheckboxes: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  years: number[] = this.generateYears(1975, new Date().getFullYear());
  newSelectedValues = [];
  Sub: any[] = [];
  AllSub: any[] = [];
  selectedOptions: any = [];

  SubjectData = [];
  StateCodeListP: any;
  filteredListStateP: any;
  districtCodeListP: any;
  filteredListDistrictP: any;
  SessionFilterList: any;
  sessionList: any;
  filteredtehasilPList: any;
  tehasilPList: any;
  tehasilCList: any[];
  filteredtehasilCList: any[];
  filteredListDistrictC: any;
  districtCodeListC: any;
  filteredListStateC: any;
  StateCodeListC: any;
  PCountryCodeList: any;
  filteredListPCountryCode: any;
  CfilteredListCountryCode: any;
  CCountryCodeList: any;
  SRList: any;
  filteredSR: any;
  dialogRef: MatDialogRef<any>;
  isformreadonly = true;
  filteredListAdmInfoCode: any;
  AdmInfoCodeList: any;
  EmpTypeCodeList: any;
  filteredListEmpTypeCode: any;
  MediumCodeList: any;
  filteredListMediumCode: any;
  collegedataList: any;
  filteredListCollege: any;
  districtList: any;
  filteredListdistrictCode: any;
  AdharPhone = false;
  AadharCard = false;
  AbcId = false
  message: string;
  fileName: string;
  fileUploadData: string;
  filename: string;
  errormessage: any;
  uploadDoc: any;
  errMsg: any;
  ShowHardCopy: boolean = false;
  ScrutinyData: any;
  hasNeetRollNo: any;
  hasNeetAppNo: any;
  hasCEEObtMarks: any;
  hasEntranceRollNo: any;
  hasEntranceEntrollNo: any;
  hasCEEMaxMarks: any;
  hasNeetObtMarks: any;
  hasNeetMaxMarks: any;
  hasCeeRollNo: any;
  hasCeeAppNo: any;
  FeeTable: any;
  IsRegStudent: any;
  isIndian : boolean = true;
  StuNationality: any;
  oldReceiptData: any[];
hasOldReceipt: boolean = false;
isFeeReceiptAlreadyPaid: boolean = false;
CourseLevel: any;

  constructor(private dialog: MatDialog, private location: Location,
    private fb: FormBuilder,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe, private overlay: Overlay,
    private route: ActivatedRoute) { }
  // studentId = 1084
  // studentId = 22
  personalDetailsFormArray;
  contactDetailsFormArray;
  reservationsDetailsFormArray;
  qualificationDetailsFormArray;
  additionalDetailsFormArray;
  admissionDetailsFormArray;
  isOpen = true;
  data = [];
  showchat = false;
  showchattt = true
  readonly = true;
  isStuCasteDisable = false
  isStuCasteCertDisable = false
  isStuCasteValCertDisable = false;
  isStuNonCrmValDtDisable = false;
  isStuOrphanTypeDisable = false;
  isStuSpecialAbledTypeDisable = false;
  isStuMinorityTypeDisable = false;
  isStuNonCrmCertDisable = false
  isStuMinorityType2Disable = false;
  isStuInHouseDisable = false;
  isStuMinorityDisable = false;
  currentdate: any;
  isStuNonCrmValDtDisable2 = false;
  disableMinority = true;
  resultNotDec = false;
  UpdateBtn = false;
  AdminUpdate: boolean = false;

  ngOnInit(): void {

    this.currentdate = new Date();
    // const state = history.state;
    // this.ScrutinyLevel = state['ScrutinyLevel'];
    // this.UserId = state['UserId'];
    // this.ScrutinyId = state['ScrutinyId'];
    // this.StudentId = state['StudentId'];
    // this.LoginName = state['LoginFullName'];
    // this.FirstName = state['StuFirstName'];
    // this.MiddleName = state['StuMidName'];
    // this.LastName = state['StuLastName'];
    // this.CoCode = state['CoCode'];
    // this.CgCode = state['CgCode'];
    // this.SessionId = state['SessionId'];
    const state = history.state;

    this.ScrutinyLevel = state['ScrutinyLevel'] || localStorage.getItem('ScrutinyLevel');
    this.UserId = state['UserId'] || localStorage.getItem('UserId');
    this.ScrutinyId = state['ScrutinyId'] || localStorage.getItem('ScrutinyId');
    this.StudentId = state['StudentId'] || localStorage.getItem('StudentId');
    this.LoginName = state['LoginFullName'] || localStorage.getItem('LoginFullName');
    this.FirstName = state['StuFirstName'] || localStorage.getItem('StuFirstName');
    this.MiddleName = state['StuMidName'] || localStorage.getItem('StuMidName');
    this.LastName = state['StuLastName'] || localStorage.getItem('StuLastName');
    this.CoCode = state['CoCode'] || localStorage.getItem('CoCode');
    this.CgCode = state['CgCode'] || localStorage.getItem('CgCode');
    this.SessionId = state['SessionId'] || localStorage.getItem('SessionId');
    this.from = state['from']
    this.fetchFeeResponces(this.SessionId, this.StudentId);
    // this.route.queryParams.subscribe(
    //   params => {
    //     this.ScrutinyLevel = params['ScrutinyLevel'];
    //     this.UserId = params['UserId'];
    //     this.ScrutinyId = params['ScrutinyId'];
    //     this.StudentId = params['StudentId'];
    //     this.LoginName = params['LoginFullName'];
    //     this.FirstName = params['StuFirstName'];
    //     this.MiddleName = params['StuMidName'];
    //     this.LastName = params['StuLastName'];
    //     this.CoCode = params['CoCode'];
    //     this.CgCode = params['CgCode'];
    //     this.SessionId = params['SessionId'];
    //     this.from = params['from']
    //   }
    // )
    this.data.push({
      "ScrtLvl": this.ScrutinyLevel,
      "UserId": this.UserId,
      "ScrtId": this.ScrutinyId,
      "StdId": this.StudentId,
      "LoginName": this.LoginName,
      "FirstName": this.FirstName,
      "MidName": this.MiddleName,
      "LastName": this.LastName,
      "CoCode": this.CoCode,
      "CgCode": this.CgCode,
      "SessionId": this.SessionId,
      "from": this.from,
    })
    this.checkLock();
    if (this.from === 'report') {
      this.showchattt = false
      this.isformreadonly = true;
      this.UpdateBtn = true;
    } else {
      this.showchattt = true
      this.isformreadonly = false;
      this.UpdateBtn = false;
    }

    let id = '';
    this.stepperForm = new FormGroup({

      personalDetailsForm: new FormControl(),
      contactDetailsForm: new FormControl(),
      reservationsDetailsForm: new FormControl(),
      qualificationDetailsForm: new FormControl(),
      additionalDetailsForm: new FormControl(),
      photoSignDetailsForm: new FormControl(),
      admissionDetailsForm: new FormControl(),
      documentDetailsForm: new FormControl(),
    });

    this.personalDetailsForm = new FormGroup({
      // Define your form fields and their validators for Step 1
      StuRgNo: new FormControl(this.StudentId),
      StuId: new FormControl(""),
    });
    this.personalDetails();


    this.contactDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuAddrId: new FormControl(""),
    });
    this.contactDetails();

    this.reservationsDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuResId: new FormControl(''),
    });
    this.reservationDetails();

    this.qualificationDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuQualId: new FormControl(),
    });
    this.prepopulationQ();

    this.additionalDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuExtraId: new FormControl(),
      WorkExperience: new FormControl('')
    });
    this.prepopulationA();
    this.fetchEmpType();
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuRgNo: new FormControl(this.StudentId),
      StuPhoto: new FormControl(''),
      StuSignature: new FormControl(''),

    });
    this.prepopulationPS();

    this.admissionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
    });
    this.admissionDetails();

    this.documentDetailsForm = this.fb.group({
      "StuRemarkConfirm": new FormControl(''),
      "StuRemarkCheck": new FormControl(''),
      "HardCopyFile": new FormControl('',Validators.required),
      arrData: this.fb.array([]),
    });
    this.fetchDocument();

    // this.openModal(id);
    this.fetchCourseLevel();
    this.fetchPassYear();
    this.fetchCourseForQual();
    this.fetchBoardUni();
  }

  ngAfterViewInit(): void {

  }
  personalDetails() {
    this.prepopulationP();
    this.ageCalculate();
    this.fetchMarritalStatus();
    this.fetchBloodGroup();
    this.fetchGender();
    this.fetchMotherTounge();
    this.fetchAdmInfo();
  }

  contactDetails() {
    this.prepopulationC();
    this.fetchCountry();
    this.fetchDistrict();
    this.fetchState();
    this.fetchNationality();
    this.fetchDomicile();
    this.fetchRegion();
    this.fetchCountryP();
    this.fetchCountryC()
  }

  reservationDetails() {
    this.prepopulationR();
    this.fetchReligion();
    this.fetchSpAbled();
    this.fetchorphanType();
    this.fetchConstiCate();
    this.fetchSocialReservation();

  }

  admissionDetails() {
    this.prepopulationAD();
    this.getFacultyData();
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getSessionData()
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  prepopulationP() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    // payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {

      if (res.status) {
        this.IsRegStudent = res.data[0].IsRegStudent;
        // this.spinner.hide();
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          //  StudentDocumentID = sessionStorage.getItem('StudentDocumentID'); EmailID
          this.data.push({ "email": res.data[0].EmailID });
          this.data.push({ "birthDate": res.data[0].StuBirthDate });
          this.data.push({ "stuRgNo": res.data[0].StuRgNo });
          this.data.push({ "StuGender": res.data[0].StuGender });
          this.data.push({ "StuNumber": res.data[0].StuNumber });
          this.data.push({ "EmailID": res.data[0].EmailID });
          this.data.push({ "StuMothNameEng": res.data[0].StuMothNameEng });
          this.prepopulatedatapageP(res);
        } else {
          this.loadsettingspageP();
        }
      } else {
        this.spinner.hide();
        this.loadsettingspageP();
      }
    })

  }
  prepopulatedatapageP(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';

    this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.personalDetailsForm.controls['StuRgNo'].setValue(e.data[0]['StuRgNo']);

    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data[27].FormControlName = "StudentRegNo";
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }
  loadsettingspageP() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });

      this.mapdataaa(res.data);
    });
  }
  updatePersonalDetails() {
    this.spinner.show();
    let submitpayload = this.personalDetailsForm.value;
    // model.dateOfBirth = new Date(moment(model.dateOfBirth).format('MM/DD/YYYY')).toDateString();
    //  this.submitpayload['StuBirthDate'] = this.datepipe.transform(this.submitpayload.StuBirthDate, 'dd/MM/yyyy');
    // var datePipe = new DatePipe("en-US");
    // this.submitpayload['StuBirthDate'] = datePipe.transform(this.submitpayload.StuBirthDate, 'dd/MM/yyyy');

    let da = this.personalDetailsForm.value.StuBirthDate;
    submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    submitpayload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.updatePersonalDetails(submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.next.emit();
        // this.umsService.openSnackbar(res.message)
        // sessionStorage.setItem("StudentPersonalId",res.data);
      });

  }

  checkLock() {
    this.spinner.show();
    this.route.queryParams.subscribe(
      params => {
        this.UpdateBtn = false;
        const payload = {};
        payload['UserId'] = parseInt(sessionStorage.getItem('userId'));
        payload['StudentId'] = parseInt(this.StudentId);
        payload['SessionId'] = parseInt(this.SessionId);
        this.umsService.ScrutinyLock(payload).subscribe((res) => {
          if (res.status) {
            this.spinner.hide();
            this.ScrutinyData = res.data[0]
            let Data = res.data[0]
            // && this.Arr['UserId'] == this.Data.HistoryUserId
            if (this.from != 'report') {
              if (Data.Status == 'APPR' && Data.FinalApproval == true && params['UserId'] == Data.HistoryUserId) {
                this.UpdateBtn = true;
                this.isformreadonly = true;
              }
            }
            else {
              this.UpdateBtn = false;
            }

          } else {
            this.spinner.hide();
            this.ScrutinyData = []
            this.UpdateBtn = false;
          }
        },
           (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.ScrutinyData = []
            this.UpdateBtn = false;
          }

        );
      })



  }
  mapdataaa(e) {
    this.personalDetailsFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }
  ageCalculate() {
    let payload = this.personalDetailsForm.value;
    if (payload.StuBirthDate) {
      var timeDiff = Math.abs(
        Date.now() - new Date(payload.StuBirthDate).getTime()
      );
      let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      this.personalDetailsForm.controls['StuAge'].setValue(age);
    }
  }
  fetchCountryP() {
    this.spinner.show();
    const payload = {};
    // payload['CountryCode'] = id;
    // payload['CountryName'] = id;
    this.StateCodeListP = []
    this.filteredListStateP = []
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.PCountryCodeList = res.data;
        this.filteredListPCountryCode = this.PCountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchCountryC() {
    this.spinner.show();
    const payload = {};
    // payload['CountryCode'] = id;
    // payload['CountryName'] = id;
    this.StateCodeListC = []
    this.filteredListStateC = []
    this.districtCodeListC = []
    this.filteredListDistrictC = []
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.filteredListStateC = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CCountryCodeList = res.data;
        this.CfilteredListCountryCode = this.CCountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }
  fetchStateP(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    // payload['CountryName'] = id;

    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
        this.contactDetailsForm.controls["StuStateP"].setValue('');

      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateP2(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []

    payload['CountryCode'] = CountryCode;
    // payload['CountryName'] = id;

    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateP3(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []

    payload['CountryCode'] = CountryCode;
    // payload['CountryName'] = id;

    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateC(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    // // this.contactDetailsForm.get('StuStateC').reset();
    // this.contactDetailsForm.controls["StuStateC"].setValue('');
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
        this.contactDetailsForm.controls["StuStateC"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateC2(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    // // this.contactDetailsForm.get('StuStateC').reset();
    // this.contactDetailsForm.controls["StuStateC"].setValue('');
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictP(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();

        this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictP2(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }

  fetchDistrictP3(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictC(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
        this.contactDetailsForm.controls["StuDistrictC"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictC2(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  getTehasilDataC(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    // payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
      this.contactDetailsForm.controls["StuTehsilC"].setValue('');
    });
  }
  getTehasilDataC2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    // payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
    });
  }
  getTehasilDataP(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    // payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
      this.contactDetailsForm.controls["StuTehsilP"].setValue('');
    });
  }
  getTehasilDataP2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    // payload['SearchString'] = this.TehasilSearchForm.value['SearchString'];
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
    });
  }
  fetchMarritalStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'MarSt';

    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.marritalList = res.data;
        this.filteredmarritalstatusList = this.marritalList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchBloodGroup() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Bld';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.bloodgroupList = res.data;
        this.filteredBloodGroupList = this.bloodgroupList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  copyAddress(e) {
    if (e.checked == true) {
      this.isreadonly = true;
      let payload = this.contactDetailsForm.value.StuAddrC;
      let payload2 = this.contactDetailsForm.value.StuCountryC;
      this.fetchStateP3(payload2);
      let payload3 = this.contactDetailsForm.value.StuStateC;
      this.fetchDistrictP3(payload3)
      let payload4 = this.contactDetailsForm.value.StuDistrictC;
      let payload6 = this.contactDetailsForm.value.StuCityC;
      let payload7 = this.contactDetailsForm.value.StuPinC;
      let payload8 = this.contactDetailsForm.value.StuAddr2C;
      let payload9 = this.contactDetailsForm.value.StuAddr3C;
      let payload10 = this.contactDetailsForm.value.StuAddr4C
      this.contactDetailsForm.controls["StuAddrP"].setValue(payload);
      this.contactDetailsForm.controls["StuCountryP"].setValue(payload2);
      this.contactDetailsForm.controls["StuStateP"].setValue(payload3);
      this.contactDetailsForm.controls["StuDistrictP"].setValue(payload4);
      this.contactDetailsForm.controls["StuCityP"].setValue(payload6);
      this.contactDetailsForm.controls["StuPinP"].setValue(payload7);
      this.contactDetailsForm.controls["StuAddr2P"].setValue(payload8);
      this.contactDetailsForm.controls["StuAddr3P"].setValue(payload9);
      this.contactDetailsForm.controls["StuAddr4P"].setValue(payload10);

    }
    else {
      this.isreadonly = false;
      this.contactDetailsForm.controls["StuAddrP"].setValue('');
      this.contactDetailsForm.controls["StuCountryP"].setValue('');
      this.contactDetailsForm.controls["StuStateP"].setValue('');
      this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      this.contactDetailsForm.controls["StuCityP"].setValue('');
      this.contactDetailsForm.controls["StuPinP"].setValue('');
      this.contactDetailsForm.controls["StuAddr2P"].setValue('');
      this.contactDetailsForm.controls["StuAddr3P"].setValue('');
      this.contactDetailsForm.controls["StuAddr4P"].setValue('');
    }
  }


  updateContaceDetails() {
    this.spinner.show();
    let payload = this.contactDetailsForm.value;
    //let payload = {};
    // payload.StuCountryC=parseInt(payload.StuCountryC);
    // payload.StuStateC=parseInt(payload.StuStateC);
    // payload.StuCountryP=parseInt(payload.StuCountryP);
    // payload.StuStateP=parseInt(payload.StuStateP);
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
      payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
      payload['StuAddr2P'] = this.contactDetailsForm.value.StuAddr2C;
      payload['StuAddr3P'] = this.contactDetailsForm.value.StuAddr3C;
      payload['StuAddr4P'] = this.contactDetailsForm.value.StuAddr4C;
      payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
      payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
      payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
      // payload['StuTehsilP'] = this.contactDetailsForm.value.StuTehsilC;
      payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
      payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;
    }
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.updateContactDetails(payload).subscribe(res => {
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      // this.umsService.openSnackbar(res.message)

    },
    );
  }


  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = res.data;
      this.SessionFilterList = this.sTypeList.slice();
    },);
  }

  fetchGender() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchMotherTounge() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Lang';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.mothertoungList = res.data;
        this.filteredMotherToungList = this.mothertoungList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  // prepopulationC() {
  //   // this.spinner.show()
  //   let payload = {};
  //   payload['StuId'] = this.StudentId;
  //   this.umsService.fetchContactDetails(payload).subscribe((res) => {
  //     // this.spinner.hide();
  //     if (res.status) {
  //       if (res.data.length > 0) {
  //         if (res.data[0].StuSameAddr == 1) {
  //           this.isreadonly = true;
  //         } else {
  //           this.isreadonly = false;
  //         }
  //         sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
  //         this.data.push({ "StuAddrC": res.data[0].StuAddrC });
  //         this.data.push({ "StuAddrP": res.data[0].StuAddrP });
  //         this.data.push({ "StuPinC": res.data[0].StuPinC });
  //         this.data.push({ "StuPinP": res.data[0].StuPinP });
  //         //  StudentDocumentID = sessionStorage.getItem('StudentDocumentID');
  //         this.prepopulatedatapageC(res);
  //       } else {
  //         this.loadsettingspageC();
  //       }
  //     } else {
  //       this.loadsettingspageC();
  //     }
  //   })
  // }

  prepopulationC() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {
          this.StuNationality = res.data[0].StuNationality;
          if(res.data[0].StuNationality  == 'OS') {
            this.isIndian = false;
          }
          else { this.isIndian = true; }
          this.fetchStateC2(res.data[0].StuCountryC);
          this.fetchStateP2(res.data[0].StuCountryP);
          this.fetchDistrictC2(res.data[0].StuStateC);
          this.fetchDistrictP2(res.data[0].StuStateP);
          //  this.getTehasilDataC2(res.data[0].StuDistrictC);
          //  this.getTehasilDataP2(res.data[0].StuDistrictP);
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.data.push({ "StuAddrC": res.data[0].StuAddrC });
          this.data.push({ "StuAddrP": res.data[0].StuAddrP });
          this.data.push({ "StuPinC": res.data[0].StuPinC });
          this.data.push({ "StuPinP": res.data[0].StuPinP });

          //  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
          this.prepopulatedatapageC(res);
        } else {
          this.loadsettingspageC();
        }
      } else {
        this.loadsettingspageC();
      }
    })
  }

  prepopulatedatapageC(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }
  loadsettingspageC() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl('')
            );
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }
  fetchCountry() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CountryCodeList = res.data;
        this.filteredListCountryCode = this.CountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }
  fetchState() {
    this.spinner.show();
    const payload = {};
    // payload['CountryCode'] = id;
    // payload['CountryName'] = id;
    this.umsService.getState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.StateCodeList = res.data;
        this.filteredListState = this.StateCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }
  fetchDistrict() {
    this.spinner.show();
    const payload = {};
    // payload['CountryCode'] = id;
    // payload['CountryName'] = id;
    this.umsService.getDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeList = res.data;
        this.filteredListDistrict = this.districtCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchNationality() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'NL';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchDomicile() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Dm';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.domicileList = res.data;
        this.filteredDomicileList = this.domicileList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchRegion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Regio';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.regionList = res.data;
        this.filteredRegionList = this.regionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchCourseLevel() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'COLVL';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchPassYear() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'PaYr';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.PassYearList = res.data;
        this.filteredPassYearList = this.PassYearList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchCourseForQual() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Cours';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseQualList = res.data;
        this.filteredcourseList = this.courseQualList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchBoardUni() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'BOARD';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  prepopulationR() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {

          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.fetchMinorityType(res.data[0].StuMinorityType);
          this.StuMinorityTypeDisable2(res.data[0])
          this.fetchCast(res.data[0].StuConstiSubCate);
          this.data.push({ "StuConstiSubCate": res.data[0].StuConstiSubCate });
          this.prepopulatedatapageR(res);
        } else {
          this.loadsettingspageR();
        }
      } else {
        this.loadsettingspageR();
      }
    })
  }
  StuMinorityTypeDisable2(e) {
    // this.stepperForm.get('StuNonCrmValDt').markAsUntouched();
    // this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
    // this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
    // this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
    // StuMinority
    if (e.StuMinority === 2 || e.StuMinority == 2) {
      this.isStuMinorityTypeDisable = true
      // this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
      this.isStuMinorityType2Disable = true
      // this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
    } else {
      this.isStuMinorityTypeDisable = false
      // this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = false
      // this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)
    }
  }
  onSelectionCastCertificat2(e) {
    if (e == '2') {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
      // this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
      // this.reservationsDetailsForm.controls['StuNonCrmCert'].setValue('')
      // this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();
      // this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();
      // this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      //  this.reservationsDetailsForm.controls['StuCasteValCert'].setErrors(null);
      // this.reservationsDetailsForm.controls['StuCasteValCert'].clearValidators();
      // this.reservationsDetailsForm.controls['StuCasteValCert'].updateValueAndValidity();

      // this.reservationsDetailsForm.controls['StuNonCrmCert'].setErrors(null);
      // this.reservationsDetailsForm.controls['StuNonCrmCert'].clearValidators();
      // this.reservationsDetailsForm.controls['StuNonCrmCert'].updateValueAndValidity();

      // this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
      // this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
      // this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
    }
    // else if(e == '1') {
    //   this.isStuCasteValCertDisable = false;
    //   this.isStuNonCrmValDtDisable = false;
    //   this.isStuNonCrmValDtDisable2 = false

    // }
  }

  StuOrphanTypeDisable2(e) {
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
    }
    else if (e == 2) {
      this.isStuOrphanTypeDisable = true
    }
  }

  StuSpecialAbledTypeDisable2(e) {
    if (e == 1) {
      this.isStuSpecialAbledTypeDisable = false
    }
    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
    }
  }
  fetchMinorityType2(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else if (value === 2) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
    else {
      this.spinner.hide()
      this.isStuMinorityType2Disable = true;
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      payload['MinorityType'] = 3;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }
  prepopulatedatapageR(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(e.data[0]['StuResId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          // } else {
          //   this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          // }
        } else {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }
  loadsettingspageR() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          this.reservationsDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
          // } else {
          //   this.reservationsDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('')
          //   );
          // }
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }
  fetchMinorityType(value) {
    this.spinner.show();
    const payload = {};
    if (value === 1) {
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else {
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }
  fetchCast(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;
      this.spinner.show()
      const payload = {};
      this.categoryList = [];
      this.filteredCategoryList = [];
      payload['CategoryId'] = value;
      this.umsService.fetchCategory(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.categoryList = res.data;
          this.filteredCategoryList = this.categoryList.slice();
          //this.castGene(payload)
        }
        else {

        }

      });
    }


  }

  fetchCast2(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.get('StuCaste').patchValue('');
      this.reservationsDetailsForm.get('StuCasteCert').patchValue(2);
      this.reservationsDetailsForm.get('StuCasteValCert').patchValue(3);
      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue(2);
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').patchValue(2);
      this.reservationsDetailsForm.get('StuMinority').patchValue(2);
      this.reservationsDetailsForm.get('StuMinorityType').patchValue(3);
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');

      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;

    }

    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CategoryId'] = value;
    this.umsService.fetchCategory(payload).subscribe((res) => {
      this.spinner.hide()
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      }
      else {

      }

    });
  }
  fetchReligion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchSpAbled() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SpAb';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.specialAbledList = res.data;
        this.filteredspecialAbledList = this.specialAbledList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchorphanType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Op';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.orphanTypeList = res.data;
        this.filteredorphanTypeList = this.orphanTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchConstiCate() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchSocialReservation() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  prepopulationQ() {
    this.spinner.show();
    // remove aftre it work
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageQ(res);
        } else {
          this.loadsettingspageQ();
        }
      } else {
        this.loadsettingspageQ();
      }
    })
  }
  prepopulatedatapageQ(e) {
    // remove omnce done 
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';

    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      // this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName],));

          // } else {
          //   this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [, Validators.pattern(element.FormPattern)]));
          // }
          // } else {
          //   this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          // }
        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
  }
  loadsettingspageQ() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      // this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.qualificationDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
          // } else {
          //   this.qualificationDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
          //   );
          // }

          // } else {
          //   this.qualificationDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('')
          //   );
          // }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
  }
  fetchQualDetailsForTable() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    payload['StuQualId'] = '';
  this.hasNeetRollNo = false;
  this.hasNeetAppNo = false;
  this.hasCeeRollNo = false;
  this.hasCeeAppNo = false;
  this.hasCEEObtMarks = false;
  this.hasCEEMaxMarks = false;
    this.hasEntranceRollNo = false;
  this.hasEntranceEntrollNo = false;
  this.hasNeetObtMarks = false;
  this.hasNeetMaxMarks = false;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.qualList = res.data;
      this.qualList.forEach((item: any) => {
      item.isViewable = false;
      if (!item.fileUploadData) {
        return;
      }
      this.umsService.fetchDocument({
        filePath: item.fileUploadData,
        viewFile: true
      }).subscribe(
        (docRes: any) => {
          item.isViewable = docRes.isViewable;
        },
        () => {
          item.isViewable = false;
        }
      );
    });

      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;
         this.hasNeetRollNo = this.qualList.some(q => !!q.StuNeetRollNo);
          this.hasNeetAppNo = this.qualList.some(q => !!q.StuNeetRgNo);
          this.hasNeetObtMarks = this.qualList.some(q => !!q.StuNeetMarksObt)
          this.hasNeetMaxMarks = this.qualList.some(q => !!q.StuNeetMarksTot)
          this.hasCeeRollNo = this.qualList.some(q => !!q.CEERollNo);
          this.hasCeeAppNo = this.qualList.some(q => !!q.CEEAppNo);
          this.hasCEEObtMarks = this.qualList.some(q => !!q.StuCEEMarksObt)
          this.hasCEEMaxMarks = this.qualList.some(q => !!q.StuCEEMarksTot)
          this.hasEntranceRollNo = this.qualList.some(q => !!q.StuEntranceRollNo);
          this.hasEntranceEntrollNo = this.qualList.some(q => !!q.StuEntranceEntrollNo);
      }
    })
  }
  onSelectionChanged2({ value }) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    } else {
      this.resultNotDec = false;
    }
  }

  onselectPrepopulate(e) {
    this.spinner.show();
    this.onSelectionChanged2(e);
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);

          // } else {
          //   this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]);

          // }
          // this.qualificationDetailsForm.addControl(element.FormControlName,new FormControl(e[element.FormControlName], Validators.required));
          // } else {
          //   this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);

          // }
        }
        else if (element.FormVisible == false) {
          // this.qualificationDetailsForm.controls[element.FormControlName].setValue('');
        }

        // else {
        //   this.qualificationDetailsForm.controls[element.FormControlName].setValue('');
        //   // this.qualificationDetailsForm.controls[element.FormControlName].setValue(null);
        // }

      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

    });

    // let bar =new promise<void>(() =>{

    // })
  }
  prepopulationA() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {
          if (res.data[0].StuABCId == 2) {
            this.AdharPhone = true;
            this.AbcId = false
          }
          else if (res.data[0].StuABCId == 1) {
            this.AdharPhone = false;
            this.AbcId = true
          }

          if (res.data[0].StuAadhar == 1) {
            this.AadharCard = true
          }
          else if (res.data[0].StuAadhar == 2) {
            this.AadharCard = false
          }
          this.fetchDate(res.data)
          this.getCollegeData(res.data[0].StuDistrictAd)
          this.getDistrictData();
          this.fetchMedium();
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          //  StudentDocumentID = sessionStorage.getItem('StudentDocumentID');
          this.prepopulatedatapageA(res);
        } else {
          this.loadsettingspageA();
        }
      } else {
        this.loadsettingspageA();
      }
    })
  }


  prepopulatedatapageA(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if(element.FormControlName == 'StuABCId') {
          element.FormVisible = true;
          element.FormRequired = false;
        }
        if(this.StuNationality == 'OS') {
          if(element.FormControlName == 'StuABCId2') {
            element.FormRequired = false;
          }
        } else {
          if(element.FormControlName == 'StuABCId2') {
            element.FormVisible = true;
            element.FormRequired = true;
          }
        }
        
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

          // } else {
          //   this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

          // }
          // } else {
          //   this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          // }
        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      if (this.additionalDetailsForm.get('WorkExperience')) {
  this.additionalDetailsForm.get('WorkExperience')?.setValue(e.data[0].FieldValue);
}
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }
  loadsettingspageA() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));
          // } else {
          //   this.additionalDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
          //   );
          // }

          // } else {
          //   this.additionalDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('')
          //   );
          // }
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }


  prepopulationPS() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();

      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto),
            StuSignature: new FormControl(data.StuSignature),
          });
          this.userImage = res.data[0].StuPhoto
          this.signatureImage = res.data[0].StuSignature
        }
        else {
        }
      } else {

      }
    })
  }

  fetchDate(item) {
    // StuFromDate
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }
  prepopulationAD() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.getFeeTempData();
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {

        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        // this.data.push({ "StrCode": parseInt(res.data[0].StuBrId) });
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        this.getExamForLateral(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);

          this.getCourseData(res.data[0].StuFacId);
          this.getExamStreamData(res.data[0].StuCoId, res.data[0].StuBrId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');

          // this.newSelectedValues = dataArray.map(item => {
          //   const values = item.split('-');
          //   return values.length > 1 ? values[1] : null;
          // });
          dataArray.forEach(item => {
            const splitValues = item.split('-');
            const obj = {
              Code: splitValues[0],
              Id: splitValues[1]
            };
            this.newSelectedValues.push(obj);
          });
          this.data.push({ "subjects": res.data[0].StuSubjectRg });
          //  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
          this.prepopulatedatapageAD(res);

        } else {
          this.showchat = true;
          this.loadsettingspageAD();
        }
      }
      else {
        this.loadsettingspageAD();
      }
    })
  }

  getExamForLateral(id) {
    const payload2 = {};
    payload2['EmId'] = id;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.data.push({ "EmSrNo": res.data[0].EmSrNo });
    });
  }
  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);

    // return this.newSelectedValues.some(item => item === child.EsId)

  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
    // return this.newSelectedValues.some(item => item === item1.EsParent)
  }
  getBrId(id) {
    this.BranchId = id;
  }

  getSubData(id) {
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.BranchId;
    this.umsService.fetchSubs(payload).subscribe(res => {
      this.spinner.hide()
      this.ErrorMessage = '';
      this.SubError = false;
      this.Subjects = [];
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.MinMax = false;
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      // this.getExamSubMapFetch(id)
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
    });
  }

  // getExamSubMapFetch(EmId,BranchId){
  //   this.Subjects = [];
  //   this.ErrorMessage = '';
  //   this.SubError = false;
  //   this.MinMax = false;
  //   this.spinner.show();
  //   const payload = {};
  //   payload['EsEmId'] = EmId;
  //   payload['EsStrId'] = BranchId;
  //   this.umsService.getExamSubMapFetch(payload).subscribe(res => {
  //     this.MinMax = false;
  //     this.ErrorMessage = '';
  //     this.SubError = false;
  //     this.spinner.hide();
  //     this.GroupData = res.data.children;
  //     res.data.children.forEach(element => {
  //       if(element.EsType == 'S'){
  //         if (this.Subjects.indexOf(element.EsCode) === -1) {
  //           this.Subjects.push(element.EsCode);
  //           this.SubjectName.push(element.EsName);
  //         } else {
  //         }

  //       }
  //       element.children.forEach(element1 => {
  //           if(element1.EsOpCode == " "){
  //             const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
  //             // If it's not a duplicate, push the new item
  //             if (!isDuplicate) {
  //               this.selectedCheckboxes.push(element1);
  //             } else {
  //             }
  //           }
  //       });

  //     });
  //   });
  // }

  // getOptionData(EmId) {
  //   this.Subs = false;
  //   this.OptSub = false;
  //   this.MinMax = false;
  //   this.SubError = false;
  //   this.Min = '';
  //   this.Max = '';
  //   this.ErrorMessage = '';
  //   this.spinner.show();
  //   const payload = {};
  //   payload['OpEmId'] = EmId;
  //   payload['OpStrId'] = '';
  //   this.umsService.getOption(payload).subscribe((res) => {
  //     this.SubError = false;
  //     this.spinner.hide();
  //     if(res.status == true){
  //       this.Subs = true;
  //       this.OptSub = false;
  //       if(res.data[0]['OpMin'] != ''){
  //         this.ErrorMessage = '';
  //         this.SubError = false;
  //         this.MinMax = true;
  //         this.Min = res.data[0]['OpMin'];
  //         this.Max = res.data[0]['OpMax']
  //       }
  //       else if(res.data[0]['OpMin'] == ''){
  //         this.ErrorMessage = '';
  //         this.MinMax = false;
  //         this.SubError = false;
  //       }
  //       if(res.data.length > 1){
  //         this.Subs = false;
  //         this.OptSub = true;
  //         this.optData = res.data;
  //       }
  //     }

  //     else if(res.status == false){
  //       this.Subs = false;
  //       this.OptSub = false;
  //       this.ErrorMessage = '';
  //       this.MinMax = false;
  //       this.SubError = false;
  //     }
  //   });

  // }

  prepopulatedatapageAD(e) {
    // this.submitButton = false;
    //      this.updateButton = true;
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';

    //  this.admissionDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

          // } else {
          //   this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
          // }
          // }
          // else {
          //   if (element.FormPattern == '') {
          //     this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          //   } else {
          //     this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          //   }
          // }
        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

  }
  loadsettingspageAD() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
          // if (element.FormPattern == '') {
          this.admissionDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
          // } else {
          //   this.admissionDetailsForm.addControl(
          //     element.FormControlName,
          //     new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
          //   );
          // }
          // } else {
          //   if (element.FormPattern == '') {
          //     this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(''));
          //   } else {
          //     this.admissionDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
          //   }

          // }
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

      // let a=''
      //  this.getExamStreamData(a);
      //  this.getCourseData(a);
    });
  }
  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      this.spinner.hide();
      this.facultyList = res.data;
      this.filteredFacultyList = this.facultyList.slice();
      //this.openDialog(res);
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });
  }
  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );

      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes: any[]): void {
    const totalSelected = selectedCheckboxes.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `Selected checkboxes should be between ${opMin} and ${opMax}`;
    } else {
      delete this.validationErrors[item.OpCode];
    }
  }


  getCourseData(id) {
    this.spinner.show();
    const payload = {};
    //"CoFcCode": "MBBS"
    payload['CoFcCode'] = id;
    //payload['EmId'] = 0;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.CourseLevel = res.data[0]['CourseLevel'];
      this.filteredCourseList = this.courseList.slice();
      //this.openDialog(res);
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });
  }
  getExamStreamData(id, StrId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {
          if (element.StrId == StrId) {
            this.data.push({ "StrCode": element.StrCode });
          }
        });

        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.showchat = true;
      } else {
        this.showchat = true;
      }

    },
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.examList = res.data;
      this.filteredExamList = this.examList.slice();
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });

    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.courseClg(payload3).subscribe(res => {
      this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });

  }

  fetchDocument() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      // this.ducumentList = res.data;
       this.ducumentList = res.data.filter(doc => {
      if (doc.StuDocumentName === 'Fee receipt already paid') {
        return !!doc.StuFileUpload; 
      }
      return true;
    });
       this.ducumentList.forEach((item: any) => {
      item.isViewable = false;

      if (!item.StuFileUpload) {
        return;
      }

      this.umsService.fetchDocument({
        filePath: item.StuFileUpload,
        viewFile: true
      }).subscribe(
        (docRes: any) => {
          item.isViewable = docRes.isViewable;
        },
        () => {
          item.isViewable = false;
        }
      );
    });

      this.isFeeReceiptAlreadyPaid = this.ducumentList.some(
      doc => doc.StuDocumentName === 'Fee receipt already paid'
      );
      this.hasOldReceipt = this.oldReceiptData && this.oldReceiptData.length > 0;
    
      if(this.ducumentList[0].HardCopyFile != null){
        this.ShowHardCopy = true;
      }
      else if(this.ducumentList[0].HardCopyFile == null){
        this.ShowHardCopy = false;
      }
      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;       
      }
      //sessionStorage.setItem("StuDocId",res.data[0].StuDocId);

    });
  }
  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = this.SessionId;
    payload['CoCode'] = this.CoCode;   //sessionStorage.getItem("StuCoId");
    payload['CgCode'] = this.CgCode;   //sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentId;
    payload['FeeType'] = 'AF';
    console.log('payload',payload);
    this.umsService.OldReceiptAdm(payload).subscribe(res => {
      this.oldReceiptData = res.data;
    })
    this.umsService.SearchFeeAdm(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.FeeTable = res.data;
        console.log('FeeTable',this.FeeTable);
        this.data.push({
        "feeTable": this.FeeTable,
        })
       this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentId)
      
      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.FeeTable = [];
        }

      }
    });
  }

  SearchFeeDetails(TempCode, StdId) {
    this.spinner.show();
    const payload = {};
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.SessionId;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });
        
        if (data == res.data[0]['TotalPaidAmount']) {
          this.PayBtn = false;
          this.PayStatus = true;
          this.FeePaid = 'Fees Paid'
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          this.PayBtn = true;
          this.PayStatus = false;
        }       

      } else {

      }
    });

  }

   addnewrecord(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['SnNo'] = this.SessionId
    data['TemplateCode'] = item.TemplateCode
    data['Fee'] = 'Registration Payment Receipt'
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: 'auto',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  fetchForupdate(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      let data = res.data[0];
      sessionStorage.setItem('StuDocId', data.StuDocId)
      if (res.status) {
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }
        // const creds = this.documentDetailsForm.controls.arrData as FormArray;
        this.documentDetailsForm = this.fb.group({
          arrData: this.fb.array([]),
          StuId: new FormControl(data.StuId),
          StuSrNo: new FormControl(data.StuSrNo, [Validators.required]),
          StuDocumentName: new FormControl(data.StuDocumentName, Validators.required),
          StuRemark: new FormControl(data.StuRemark, Validators.required),
          StuFileUpload: new FormControl(data.StuFileUpload),
          StuRemarkConfirm: new FormControl(data.StuRemarkConfirm),
          StuRemarkCheck: new FormControl(StuRemarkCheck),
        });
        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo, [Validators.required]);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
      }
    });
  }


showbase64(e: any) {
  const data = e.fileUploadData;
  sessionStorage.removeItem('filePath');
  sessionStorage.removeItem('pdfData')
    if (!data || data === 'null' || data === 'undefined' || data.trim() === '') {
            let data = {}
        data['message'] = 'Document not submitted.';
        data['title'] = 'Information'
        data['icon'] = 'fas fa-info-circle'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
        })
    return;
  }
    else {

        sessionStorage.setItem('filePath', data);
        window.open('/pdf-viewer', '_blank');
      }
  //sessionStorage.setItem('pdfData', data);
  //window.open('/pdf-viewer', '_blank');
}

showbase642(e: any) {
  const data = e.StuFileUpload;
  sessionStorage.removeItem('filePath');
  sessionStorage.removeItem('pdfData')
   if (!data || data === 'null' || data === 'undefined' || data.trim() === '') {
            let data = {}
        data['message'] = 'Document not submitted.';
        data['title'] = 'Information'
        data['icon'] = 'fas fa-info-circle'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
        })
    return;
  }
  else {

        sessionStorage.setItem('filePath', data);
        window.open('/pdf-viewer', '_blank');
      }

}

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); 
  }



  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = BranchId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      this.spinner.hide();
      this.SubjectData = res.data.children;
      this.SubjectData.forEach(element => {
        if (element.EsType == 'S') {
          this.Subs = true;
          if (this.Subjects.indexOf(element.EsCode) === -1) {
            this.Subjects.push(element.EsCode);
            this.SubjectName.push(element.EsName);
            this.Sub.push(element.EsOpCode)
            this.AllSub.push(element)
            if (element.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
          }
          if (element.EsOpCode == " " && element.EsType == 'S') {
            const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.selectedCheckboxes.push(element);
            }
          }
          // this.selectedValues.forEach(element2 => {

          //   if (element2 == element.EsCode) {

          //     const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
          //     if (!isDuplicate) {
          //       this.selectedCheckboxes.push(element);
          //     }
          //   }
          // });
          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }
          })
        }
        else if (element.EsType == 'G') {
          // for (const value of this.selectedValues) {
          //   if (element.EsCode == value) {
          //     const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
          //     if (!isDuplicate) {
          //       this.selectedCheckboxes.push(element);
          //     }
          //   }
          // }
          // for(const value of this.newSelectedValues){
          //   if (element.EsId == value) {
          //     const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
          //     if (!isDuplicate) {
          //       this.selectedCheckboxes.push(element);
          //     }
          //   }
          // }

          this.OptSub = true;
          if (element.EsOpCode !== ' ') {
            const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
            if (!DupOpt) {
              this.selectedOptions.push(element.EsOpCode);
            }
          }
          const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
          if (!isDuplicate) {
            this.GroupData.push(element);
          }
          element.children.forEach(element1 => {
            if (element1.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element1.EsOpCode);
              }
            }

            if (element1.EsOpCode == " ") {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element1);
              }
            }

            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }

              }

            })
          });

          // for (const value of this.selectedValues) {

          //   element.children.forEach(element2 => {
          //     if (element2.EsOpCode !== ' ') {
          //       const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
          //       if (!DupOpt) {
          //         this.selectedOptions.push(element2.EsOpCode);
          //       }
          //     }
          //     if (element2.EsCode == value) {
          //       const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element2.EsId);
          //       if (!isDuplicate) {
          //         this.selectedCheckboxes.push(element2);
          //       }
          //     }
          //   });
          // }
          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsId) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }

          })
          for (const value of this.newSelectedValues) {
            element.children.forEach(element2 => {
              if (element2.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element2.EsOpCode);
                }
              }
            });
          }

        }
      });
      await this.getOptionData(EmId, BranchId);
    });


  }


  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = BranchId;
    this.umsService.getOption(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status == true) {
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        // this.optData = res.data.find(item => item.OpCode === group.EsOpCode);
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.MinMax = false;
      }
    });
  }


  onSelectionCastCertificat(e) {
    if (e === '1') {
      this.isStuCasteValCertDisable = false
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
    } else {
      this.isStuCasteValCertDisable = true
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue(2)
    }
  }

  StuNonCrmValDtDisable(e) {
    if (e === '1' || e === 1) {
      this.isStuNonCrmValDtDisable = false
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    } else {
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.isStuNonCrmValDtDisable = true
      // this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    }
  }

  StuOrphanTypeDisable(e) {
    this.isStuOrphanTypeDisable = false
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('')
    } else {
      this.isStuOrphanTypeDisable = true
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('NA')
    }
  }



  StuSpecialAbledTypeDisable(e) {
    this.isStuSpecialAbledTypeDisable = false
    if (e == 1) {

      this.isStuSpecialAbledTypeDisable = false
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('')
    }

    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('NA')

    }
  }



  StuMinorityTypeDisable(e) {
    if (e === 1) {
      this.isStuMinorityTypeDisable = false
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
      this.isStuMinorityType2Disable = false
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
    } else {
      this.isStuMinorityTypeDisable = true
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)

    }
  }



  fetchAdmInfo() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ADINF';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.AdmInfoCodeList = res.data;
        this.filteredListAdmInfoCode = this.AdmInfoCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  fetchEmpType() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ET';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.EmpTypeCodeList = res.data;
        this.filteredListEmpTypeCode = this.EmpTypeCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getDistrictData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtList = res.data;
        this.filteredListdistrictCode = this.districtList.slice();
      }
      else {
        this.spinner.hide();
        this.districtList = []
      }

    }, (ERROR: HttpErrorResponse) => {
      // let  data = {}
      this.spinner.hide();
      // data['message'] = ERROR.error.message
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-box-open'
      // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }

  getCollegeData(dsCode) {
    this.spinner.show();
    const payload = {};
    payload['DsCode'] = dsCode
    this.umsService.DistrictWiseCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegedataList = res.data;
      this.filteredListCollege = this.collegedataList.slice();

    }, (ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  fetchMedium() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.MediumCodeList = res.data;
        this.filteredListMediumCode = this.MediumCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  fetchFeeResponces(SnNo, StuId) {
    // this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = SnNo;
    this.umsService.getFeeResponse(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide();
      } else {
        // this.spinner.hide();
        this.showchattt = false
        this.message = "Fees Not Paid"
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
    })
  }


  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    this.filename = '';  // Clear the filename
    this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  showbase643(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e
      });
  }

  nationalitySelection(data:any) {
    if(data.CdCode == 'OS') {
      this.isIndian = false;
    }
    else { this.isIndian = true; }
  }

  SaveDocUpload(){
    const payload = {};
    payload['UserId'] = parseInt(sessionStorage.getItem('userId'));
    payload['StudentId'] = this.StudentId;
    payload['SessionId'] = this.SessionId;
    this.umsService.ScrutinyLock(payload).subscribe((res) => {
      if (res.status) {
        let Data = res.data[0]
        
        console.log('this.ScrutinyData',this.ScrutinyData);
        
        if (Data.Status == 'APPR' && Data.FinalApproval == true && parseInt(sessionStorage.getItem('userId')) == Data.HistoryUserId) {
          if(this.documentDetailsForm.value['HardCopyFile'] == '' || this.uploadDoc == ''){
            this.documentDetailsForm.get('HardCopyFile').markAsTouched()
          }
          else{
            this.SaveDoc()
          }
        }
        else {
          let data = {}
          data['message'] = 'Scrutiny Not Approved';
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          
        }
      } else {
        this.spinner.hide()
        let data = {}
        data['message'] = 'Scrutiny Not Approved';
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = 'Scrutiny Not Approved';
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  SaveDoc() {
    this.spinner.show()
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.ducumentList.forEach((element, index, array) => {
        let da = element.StuDocIssue;
        let da1 = element.StuDocExpiry;
        let payload = {};
        payload['StuId'] = this.StudentId;
        payload['StuSrNo'] = element.StuSrNo;
        payload['StuDocumentName'] = element.StuDocumentName;
        payload['StuRemark'] = element.StuRemark;
        payload['StuFileUpload'] = element.StuFileUpload
        payload['StuRemarkConfirm'] = element.StuRemarkConfirm;
        payload['StuRemarkCheck'] = element.StuRemarkCheck;
        payload['StuHardCopy'] = element.StuHardCopy;
        payload['CoCode'] = this.CoCode;
        payload['CgCode'] = this.CgCode;
        payload['SessionId'] = this.SessionId;
        payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
        payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
        payload['StuDocId'] = element.StuDocId;
        payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
        payload['HardCopyFile'] = this.uploadDoc ? this.uploadDoc : element.HardCopyFile;
        setTimeout(() => {
          this.umsService.updateDocumentDetails(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              this.spinner.hide();
              iserror = true;
              this.errMsg = res.message;
            } else {
              this.spinner.hide();
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();

          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = 'Uploaded Successfully';
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fetchDocument()
        })
        this.spinner.hide()
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  SuperAdminLogin() {
    const dialogRef = this.dialog.open(SuperAdminLoginComponent, {
      width: '500px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.updateFlag) {
        this.AdminUpdate = result.updateFlag;
      }
    });
  }
}
